import { UserIcon } from '@hugeicons/react'
import _ from 'lodash'

import { Avatar } from '@/shared/ui/Avatar'
import { Card } from '@/shared/ui/Card'

import { MatchedTagList } from './MatchedTagList'

import type { SuggestedPerson, Suggestion } from '../model/types'

/**
 * Sem navegação de destino: não existe tela de perfil público de participante na
 * gamificação, e criar uma seria escopo sem fonte. Os dados que a sugestão
 * justifica ficam no próprio card. Quando a tela existir, o card ganha o link.
 */
export const PersonSuggestionCard = ({
  suggestion
}: {
  suggestion: Suggestion<SuggestedPerson>
}) => {
  const { record, matched_tags: matchedTags } = suggestion
  const profile = record.networking_profile
  const hasAvatar = !_.isEmpty(record.avatar)

  const subtitle = [profile?.job_title, profile?.company]
    .filter(Boolean)
    .join(' · ')

  return (
    <Card className="p-4">
      <div className="flex items-start gap-3">
        <div className="h-11 w-11 shrink-0 overflow-hidden rounded-full bg-brand-surface">
          {hasAvatar ? (
            <Avatar config={record.avatar} showFullBody={false} className="" />
          ) : (
            <div className="flex h-full w-full items-center justify-center">
              <UserIcon size={20} className="text-gray-400" />
            </div>
          )}
        </div>

        <div className="min-w-0 flex-1">
          <p className="text-base font-semibold text-foreground">
            {record.name ?? 'Participante'}
          </p>

          {profile?.headline && (
            <p className="mt-0.5 text-sm text-gray-700">{profile.headline}</p>
          )}

          {subtitle && (
            <p className="mt-0.5 text-sm text-gray-700">{subtitle}</p>
          )}

          <div className="mt-3">
            <MatchedTagList tags={matchedTags} />
          </div>
        </div>
      </div>
    </Card>
  )
}
